import React from 'react';

import {
    STORE_LOADING_COVER_FOREGROUND,
    STORE_LOADING_COVER_SPINNER_CLASS,
    STORE_LOADING_COVER_SPINNER_SIZE,
    STORE_LOADING_COVER_TEST_IDS,
} from '../StoreLoadingCover.consts';

export function StoreLoadingCoverSpinner(): React.ReactElement {
    return (
        <span
            className={STORE_LOADING_COVER_SPINNER_CLASS}
            data-testid={STORE_LOADING_COVER_TEST_IDS.legacySpinner}
            aria-hidden="true"
            style={{
                boxSizing: 'border-box',
                display: 'inline-block',
                width: STORE_LOADING_COVER_SPINNER_SIZE,
                height: STORE_LOADING_COVER_SPINNER_SIZE,
                border: `4px solid ${STORE_LOADING_COVER_FOREGROUND}`,
                borderTopColor: 'transparent',
                borderRadius: '50%',
                flexShrink: 0,
            }}
        />
    );
}
